import React from 'react';

export const InputCloseIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="5.5" width="15" height="7" rx="1.5" stroke="#1477F8"/>
        <path d="M10 5V13" stroke="#1477F8"/>
    </svg>
)
